import SidebarNavItem from "./SidebarNavItem";
import { isNavPathActive } from "../../navigation/adminNavConfig";

export default function SidebarGroup({
  group,
  open,
  onToggle,
  labelsVisible,
  badges,
  pathname,
  onNavigate,
}) {
  const childActive = group.children.some((child) => isNavPathActive(pathname, child));
  const expanded = open && labelsVisible;

  return (
    <div>
      <SidebarNavItem
        item={group}
        active={childActive}
        labelsVisible={labelsVisible}
        isGroup
        expanded={expanded}
        onToggle={onToggle}
      />
      <div
        aria-hidden={expanded ? undefined : true}
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          expanded ? "max-h-[48rem] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="mr-4 mt-0.5 space-y-0.5 border-r border-slate-200 pr-2">
          {group.children.map((child) => (
            <SidebarNavItem
              key={child.id}
              item={child}
              active={isNavPathActive(pathname, child)}
              labelsVisible={labelsVisible}
              badge={badges?.[child.badgeKey]}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
